var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Modal',{attrs:{"id":"passwordFailed","title":_vm.modalTitle},on:{"close":_vm.toFogotPassword,"ok":_vm.toFogotPassword}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.modalText))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }